import { render, staticRenderFns } from "./BindsListItemContent.vue?vue&type=template&id=c1bbe4e4&"
import script from "./BindsListItemContent.vue?vue&type=script&lang=js&"
export * from "./BindsListItemContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports